import styled from "styled-components";
import { FaFileDownload } from "react-icons/fa";

const Container = styled.div`
  margin: 0 auto;
  padding: 2rem 3rem;
  font-family: "Montserrat", sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  margin-top: 4.5rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
    /* margin-top: 2rem; */
    margin-bottom: 1rem;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    padding: 1rem 0.75rem;
    /* margin-top: 1rem; */
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1rem;
  color: #2c3e50;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.75rem;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 600;
  margin: 2.5rem 0 1rem 0;
  color: #34495e;
  border-bottom: 2px solid #3498db;
  padding-bottom: 0.5rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin: 2rem 0 0.75rem 0;
  }

  @media (max-width: 480px) {
    font-size: 1.3rem;
    margin: 1.5rem 0 0.5rem 0;
  }
`;

const SubSectionTitle = styled.h3`
  font-size: 1.4rem;
  font-weight: 600;
  margin: 2rem 0 1rem 0;
  color: #2c3e50;

  @media (max-width: 768px) {
    font-size: 1.25rem;
    margin: 1.5rem 0 0.75rem 0;
  }

  @media (max-width: 480px) {
    font-size: 1.1rem;
    margin: 1.25rem 0 0.5rem 0;
  }
`;

const Paragraph = styled.p`
  margin-bottom: 1.5rem;
  text-align: left;
  color: #444;
  font-size: 1rem;

  @media (max-width: 768px) {
    margin-bottom: 1.25rem;
    /* font-size: 1rem; */
  }

  @media (max-width: 480px) {
    margin-bottom: 1rem;
    /* font-size: 0.9rem; */
    text-align: left;
  }
`;

const StrongText = styled.strong`
  color: #2c3e50;
  font-weight: 600;
  margin-right: 0.5rem;

  @media (max-width: 480px) {
    margin-right: 0.25rem;
  }
`;

const IntroCard = styled.div`
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }

  @media (max-width: 480px) {
    margin-bottom: 1rem;
  }
`;

const SectionCard = styled.div`
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    margin-bottom: 2.5rem;
  }

  @media (max-width: 480px) {
    margin-bottom: 2rem;
  }
`;

const SubSectionCard = styled.div`
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }

  @media (max-width: 480px) {
    margin-bottom: 1.25rem;
  }
`;

const ContactName = styled.div`
  font-weight: 500;
  margin-bottom: 4px;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const ContactTitle = styled.div`
  /* font-style: italic; */
  margin-bottom: 4px;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const CompanyName = styled.div`
  margin-bottom: 4px;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const OfficeAddress = styled.div`
  margin-bottom: 0;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const Note = styled.p`
  font-size: 1.25rem;
  font-style: italic;
  font-weight: 600;
  color: #555;
  margin-top: 20px;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-top: 15px;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    margin-top: 10px;
  }
`;

const Link = styled.a`
  color: #007bff;
  padding: 0 5px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 480px) {
    padding: 0 3px;
  }
`;

const PrivacyContent = () => {
  const isPrivacyPage = window.location.pathname === "/privacy";

  return (
    <Container>
      <Title>{isPrivacyPage ? "Privacy Policy" : "Terms & Conditions"}</Title>

      <Paragraph
        style={{
          textAlign: "center",
          fontStyle: "italic",
          marginBottom: "2rem",
          color: "#7f8c8d",
        }}
      >
        {`Last Updated: August 1, 2025`}
      </Paragraph>

      <IntroCard>
        <Paragraph>
          YuCampus Technologies Private Limited registered office is M-11, south
          extension part-2. "YuCampus" respects your privacy and is committed to
          protecting it through our compliance with this privacy policy. This
          policy describes: The types of information that we may collect from
          you when you access or use our websites, applications and other online
          services (collectively, our "Services"); and our practices for
          collecting, using, maintaining, protecting and disclosing that
          information. This policy applies only to information we collect
          through our Services, in email, text and other electronic
          communications sent through or in connection with our Services.
        </Paragraph>
        <Paragraph>
          This policy DOES NOT apply to information that you provide to, or that
          is collected by, any third-party, such as educational institutions,
          content providers, or third-party integrations that you use in
          connection with our Services and social networks that you use in
          connection with our Services. We encourage you to consult directly
          with such third-parties about their privacy practices.
        </Paragraph>
        <Paragraph>
          Please read this policy carefully to understand our policies and
          practices regarding your information and how we will treat it. If you
          do not agree with our policies and practices, your choice is not to
          use our Services. By accessing or using our Services, you agree to
          this privacy policy. This policy may change from time to time, your
          continued use of our Services after we make changes is deemed to be
          acceptance of those changes, so please check the policy periodically
          for updates.
        </Paragraph>
      </IntroCard>

      <SectionCard>
        <SectionTitle>
          I. The Information We Collect and How We Use It
        </SectionTitle>
        <Paragraph>
          We collect several types of information from and about users of our
          Services, including information: by which you may be personally
          identified; and/or about your internet connection, the equipment you
          use to access our Services and your usage details.
        </Paragraph>
        <Paragraph>
          We collect this information: directly from you when you provide it to
          us; and/or automatically as you navigate through our Services
          (information collected automatically may include usage details, IP
          addresses and information collected through cookies, web beacons and
          other tracking technologies).
        </Paragraph>

        <SubSectionCard>
          <SubSectionTitle>Information You Provide to Us</SubSectionTitle>
          <Paragraph>
            The information we collect on or through our Services may include:
          </Paragraph>
          <Paragraph>
            <StrongText>Your Account Information:</StrongText>
            Your full name, email address, postal code, password and other
            information you may provide with your account, such as your gender,
            mobile phone number and website. Your profile picture that will be
            publicly displayed as part of your account profile. You may
            optionally provide us with this information through third-party
            sign-in services such as Facebook and Google Plus. In such cases, we
            fetch and store whatever information is made available to us by you
            through these sign-in services.
          </Paragraph>
          <Paragraph>
            <StrongText>Your Preferences:</StrongText> Your preferences and
            settings such as time zone and language.
          </Paragraph>
          <Paragraph>
            <StrongText>Your Content:</StrongText>
            Information you provide through our Services, including your course
            materials, assignments, comments, discussions, student rosters, the
            users you follow, current and prior course enrollment details,
            educational history, favorite courses, special accommodation
            requests, contact information of people you add to, or notify of,
            your courses through our Services, names, and other information you
            provide on our Services, and other information in your account
            profile.
          </Paragraph>
          <Paragraph>
            <StrongText>Your Searches and Other Activities:</StrongText> The
            search terms you have looked up and results you selected. Your
            browsing information: How long you used our Services and which
            features you used; the ads you clicked on.
          </Paragraph>

          <Paragraph>
            <StrongText>Your Communications:</StrongText>
            Communications between you and other users or educators through our
            Services; your participation in a survey, poll, contest or promotion
            scheme; your request for certain features (e.g., newsletters,
            updates or other products); your communication with us about
            employment opportunities posted to the services.
          </Paragraph>
          <Paragraph>
            <StrongText>Your Transactional Information:</StrongText>
            If you make purchases through our Services, we may collect and store
            information about you to process your requests and automatically
            complete forms for future transactions, including (but not limited
            to) your phone number, address, email, billing information and
            credit or payment card information. This information may be shared
            with third-parties which assist in processing and fulfilling your
            requests, including PCI compliant payment gateway processors. When
            you submit credit or payment card information, we encrypt the
            information using industry standard technologies, as further
            described below under "Payment Card Information." If you write
            reviews about educational institutions or courses with which you
            conduct transactions through our Services, we may publicly display
            information that you transacted with those institutions.
          </Paragraph>
          <Paragraph>
            <StrongText>Your Public Posts:</StrongText>
            You also may provide information (such as ratings, reviews, tips,
            photos, comments, likes, bookmarks, friends, lists, etc.) to be
            published or displayed (hereinafter, "posted") on publicly
            accessible areas of our Services, or transmitted to other users of
            our Services or third-parties (collectively, "User Contributions").
            Your User Contributions are posted on and transmitted to others at
            your own risk. Although we limit access to certain pages, you may
            set certain privacy settings for such information by logging into
            your account profile. Please be aware that no security measures are
            perfect or impenetrable (see "Security" section below).
            Additionally, we cannot control the actions of other users of our
            Services with whom you may choose to share your User Contributions.
            Therefore, we cannot and do not guarantee that your User
            Contributions will not be viewed by unauthorized persons. We may
            display this information on the Services, share it with educational
            institutions, and further distribute it to a wider audience through
            third party sites and services. You should be careful about
            revealing any sensitive details about yourself in such postings.
          </Paragraph>
          <Paragraph>
            We use the information you provide to us to enhance the
            functionality and improve the quality of our Services, and to
            personalize your experience while using our Services. We also use
            this information to display relevant advertising, provide support to
            you, communicate with you, and comply with our legal obligations.
          </Paragraph>
        </SubSectionCard>

        <SubSectionCard>
          <SubSectionTitle>Information About Your Friends</SubSectionTitle>
          <Paragraph>
            You have the option to request your friends to join the Services by
            providing their contact information. If you request a friend to join
            and connect with you on the Services, we will only use your friend's
            contact information to process your request.
          </Paragraph>
        </SubSectionCard>

        <SubSectionCard>
          <SubSectionTitle>Information About Your Messages</SubSectionTitle>
          <Paragraph>
            If you exchange messages with others through the Services, we may
            store them in order to process and deliver them, allow you to manage
            them, and investigate possible violations of our Terms of Service
            and wrongdoing in connection with the Services. If you send
            information from the Services to your mobile device via SMS text
            message, we may log your phone number, phone carrier, and the date
            and time that the message was processed. Carriers may charge
            recipients for texts that they receive
          </Paragraph>
        </SubSectionCard>

        <SubSectionCard>
          <SubSectionTitle>
            Information We Collect Through Automatic Data Collection
            Technologies
          </SubSectionTitle>
          <Paragraph>
            We may automatically collect certain information about the computer
            or devices (including mobile devices) you use to access the
            Services, and about your use of the Services, even if you use the
            Services without registering or logging in.
          </Paragraph>
          <Paragraph>
            <StrongText>Usage Information:</StrongText>
            Details of your use of our Services, including traffic data,
            location data, logs and other communication data and the resources
            that you access and use on or through our Services.
          </Paragraph>
          <Paragraph>
            <StrongText>Computer and Device Information:</StrongText>{" "}
            Information about your computer, Internet connection and mobile
            device, including your IP address, operating systems, platforms,
            browser type, other browsing information (connection, speed,
            connection type etc.), device type, device's unique device
            identifier, mobile network information and the device's telephone
            number.
          </Paragraph>
          <Paragraph>
            <StrongText>Stored Information and Files:</StrongText>
            Our applications also may access metadata and other information
            associated with other files stored on your mobile device. This may
            include, for example, photographs, audio and video clips, personal
            contacts and address book information.
          </Paragraph>
          <Paragraph>
            <StrongText>Location Information:</StrongText>
            Our applications collect real-time information about the location of
            your device, as permitted by you.
          </Paragraph>
          <Paragraph>
            <StrongText>Last URL Visited:</StrongText> The URL of the last web
            page you visited before visiting our websites.
          </Paragraph>
          <Paragraph>
            <StrongText>Mobile Device IDs:</StrongText>
            Unique mobile device identifier (e.g. IDFA or other device IDs on
            Apple devices like the iPhone and iPad), if you're using our
            Services on a mobile device, we may use mobile device IDs (the
            unique identifier assigned to a device by the manufacturer), instead
            of cookies, to recognize you. We may do this to store your
            preferences and track your use of our applications. Unlike cookies,
            mobile device IDs cannot be deleted. Advertising companies may use
            device IDs to track your use of our applications, track the number
            of advertisements displayed, measure advertising performance and
            display advertisements that are more relevant to you. Analytics
            companies may use mobile device IDs to track your usage of our
            applications.
          </Paragraph>
          <Paragraph>
            <StrongText>Your Activity on the Services:</StrongText>
            Information about your activity on the Services, such as your search
            queries, comments, domain names, search results selected, number of
            clicks, pages viewed and the order of those pages, how long you
            visited our Services, the date and time you used the Services, error
            logs, and other similar information.
          </Paragraph>
          <Paragraph>
            <StrongText>Mobile Status:</StrongText> For mobile application
            users, the online or offline status of your application.
          </Paragraph>
          <Paragraph>
            <StrongText>Applications:</StrongText>
            If you use the YuCampus application, YuCampus may collect
            information about the presence and/or absence and/or details
            pertaining to other applications on your mobile phone. The
            applications we gather information for, may vary across categories
            including, without limitation, education, productivity,
            communication and study tools. This will help us understand you and
            your preferences better and enable YuCampus to provide you with a
            personalised experience.
          </Paragraph>
        </SubSectionCard>

        <SubSectionCard>
          <SubSectionTitle>Cookies and Other Electronic Tools</SubSectionTitle>
          <Paragraph>
            We, and third parties with whom we partner, may use cookies, pixel
            tags, web beacons, mobile device IDs, "flash cookies" and similar
            files or technologies to collect and store information in respect to
            your use of the Services and third party websites. A cookie is a
            small text file that is stored on your computer that enables us to
            recognize you (for example, as a registered user) when you visit our
            website, store your preferences and settings, enhance your
            experience by delivering content and advertising specific to your
            interests, perform research and analytics, track your use of our
            Services, and assist with security and administrative functions.
            Cookies may be persistent or stored only during an individual
            session.
          </Paragraph>
          <Paragraph>
            A pixel tag (also called a web beacon or clear GIF) is a tiny
            graphic with a unique identifier, embedded invisibly on a webpage
            (or an online ad or email), and is used to count or track things
            like activity on a webpage or ad impressions or clicks, as well as
            to access cookies stored on users' computers. We also may include
            web beacons in e-mail messages or newsletters to determine whether
            the message has been opened and for other analytics.
          </Paragraph>
          <Paragraph>
            Most browsers are set to automatically allow cookies. Please note it
            may be possible to disable some (but not all) cookies through your
            device or browser settings, but doing so may interfere with
            certainfunctionality on the Services. Major browsers provide users
            with various options when it comes to cookies. Users can usually set
            their browsers to block all third-party cookies (which are those set
            by third-party companies collecting information on websites operated
            by other companies), block all cookies (including first-party
            cookies such as the ones YuCampus uses to collect search activity
            information about its users), or block specific cookies. To modify
            your cookie settings, please visit your browser's help settings. You
            will need to opt out on each browser and each device you use to
            access the Services. Flash cookies operate differently than browser
            cookies and cannot be removed or blocked via web browser settings.
            By using our Services with your browser set to accept cookies you
            are consenting to our use of cookies in the manner described in this
            section.
          </Paragraph>
          <Paragraph>
            Third parties whose products or services are accessible or
            advertised through the Services, including social media services,
            may also use cookies or similar tools, and we advise you to check
            their privacy policies for information about their cookies and other
            practices. We do not control the practices of such partners and
            their privacy policies govern their interactions with you.
          </Paragraph>
        </SubSectionCard>

        <SubSectionCard>
          <SubSectionTitle>Information from Third Parties</SubSectionTitle>
          <Paragraph>
            We may collect, process and store your user ID associated with any
            social media account (such as your Facebook and Google account) that
            you use to sign into the Services or connect with or use with the
            Services. When you sign in to your account with your social media
            account information, or otherwise connect to your social media
            account with the Services, you consent to our collection, storage,
            and use, in accordance with this Privacy Policy, of the information
            that you make available to us through the social media interface.
            This could include, without limitation, any information that you
            have made public through your social media account, information that
            the social media service shares with us, or information that is
            disclosed during the sign-in process. Please see your social media
            provider's privacy policy and help center for more information about
            how they share information when you choose to connect your account.
          </Paragraph>
          <Paragraph>
            We may also obtain information about you from third parties such as
            partners, marketers, third-party websites, and researchers, and
            combine that information with information which we collect from or
            about you.
          </Paragraph>
        </SubSectionCard>

        <SubSectionCard>
          <SubSectionTitle>Anonymous or De-Identified Data</SubSectionTitle>
          <Paragraph>
            We may anonymize and/or de-identify information collected from you
            through the Services or via other means, including via the use of
            third-party web analytic tools as described below. As a result, our
            use and disclosure of aggregated and/or de-identified information is
            not restricted by this Privacy Policy, and it may be used and
            disclosed to others without limitation.
          </Paragraph>
        </SubSectionCard>
      </SectionCard>

      <SectionCard>
        <SectionTitle>II. How We Use the Information We Collect</SectionTitle>

        <Paragraph>
          We use the information we collect from and about you for a variety of
          purposes, including to:
        </Paragraph>
        <Paragraph>Process and respond to your queries</Paragraph>
        <Paragraph>
          Understand our users (what they do on our Services, what features they
          like, how they use them, etc.), improve the content and features of
          our Services (such as by personalizing content to your interests),
          process and complete your transactions, and make special offers.
        </Paragraph>
        <Paragraph>
          Administer our Services and diagnose technical problems.
        </Paragraph>
        <Paragraph>
          Send you communications that you have requested or that may be of
          interest to you.
        </Paragraph>
        <Paragraph>
          Send you questions from other users that you may be able to answer if
          you have registered with YuCampus.
        </Paragraph>
        <Paragraph>
          Enable us to show you ads that are relevant to you.
        </Paragraph>
        <Paragraph>
          Generate and review reports and data about, and to conduct research
          on, our user base and Service usage patterns.
        </Paragraph>
        <Paragraph>Administer contests and sweepstakes.</Paragraph>
        <Paragraph>Provide you with customer support.</Paragraph>
        <Paragraph>Provide you with notices about your account.</Paragraph>
        <Paragraph>
          Carry out our obligations and enforce our rights arising from any
          contracts entered into between you and us, including for billing and
          collection.
        </Paragraph>
        <Paragraph>Notify you about changes to our Services.</Paragraph>
        <Paragraph>
          Allow you to participate in interactive features offered through our
          Services.
        </Paragraph>
        <Paragraph>
          In any other way we may describe when you provide the information.
        </Paragraph>
        <Paragraph>For any other purpose with your consent.</Paragraph>
        <Paragraph>
          We may also use your information to contact you about our own and
          third-party goods and services that may be of interest to you. If you
          do not want us to use your information in this way, please check the
          relevant box located on the form on which we collect your data and/or
          adjust your user preferences in your account profile.
        </Paragraph>
        <Paragraph>
          We may use the information we have collected from you to enable us to
          display advertisements to our advertisers' target audiences. Even
          though we do not disclose your personal information for these purposes
          without your consent, if you click on or otherwise interact with an
          advertisement, the advertiser may assume that you meet its target
          criteria.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>
          III. How We Share the Information We Collect
        </SectionTitle>
        <Paragraph>
          We may disclose personal information that we collect or you provide,
          as described in this privacy policy, in the following ways:
        </Paragraph>

        <SubSectionCard>
          <SubSectionTitle>General Information Disclosures</SubSectionTitle>

          <Paragraph>
            To our subsidiaries and affiliates, which are entities under common
            ownership or control of our company YuCampus Technologies Private
            Limited.
          </Paragraph>
          <Paragraph>
            To contractors, service providers and other third-parties whom we
            use to support our business and who are bound by contractual
            obligations to keep personal information confidential and use it
            only for the purposes for which we disclose it to them.
          </Paragraph>
          <Paragraph>
            To a buyer or other successor in the event of a merger, divestiture,
            restructuring, reorganization, dissolution or other sale or transfer
            of some or all of YuCampus Technologies Private Limited assets,
            whether as a going concern or as part of bankruptcy, liquidation or
            similar proceeding, in which personal information held by YuCampus
            Technologies Private Limited about the users of our Services are
            among the assets transferred.
          </Paragraph>
          <Paragraph>
            To third-parties to market their products or services to you if you
            have consented to receive the promotional updates. We contractually
            require these third-parties to keep personal information
            confidential and use it only for the purposes for which we disclose
            it to them.
          </Paragraph>
          <Paragraph>
            To fulfill the purpose for which you provide it.
          </Paragraph>
          <Paragraph>
            For any other purpose disclosed by us when you provide the
            information.
          </Paragraph>

          <Paragraph>
            <StrongText>Service Providers:</StrongText>
            We may share your information with outside vendors that we use for a
            variety of purposes, such as to send you emails and messages on
            behalf of other YuCampus members, push notifications to your mobile
            device on our behalf, provide voice recognition services to process
            your spoken queries and questions, help us analyze use of our
            Services, and process and collect payments. Some of our products,
            services and databases are hosted by third party hosting services
            providers. We also may use vendors for other projects, such as
            conducting surveys or organizing sweepstakes for us. We may share
            information about you with these vendors only to enable them to
            perform their services.
          </Paragraph>
          <Paragraph>
            <StrongText>Legal Purposes:</StrongText>
            We may share your information when we believe in good faith that
            such sharing is reasonably necessary in order to investigate,
            prevent, or take action regarding possible illegal activities or to
            comply with legal process. We may also share your information to
            investigate and address threats or potential threats to the physical
            safety of any person, to investigate and address violations of this
            Privacy Policy or the Terms of Service, or to investigate and
            address violations of the rights of thirdparties and/or to protect
            the rights, property and safety of YuCampus Technologies Private
            Limited, our employees, users, or the public. This may involve the
            sharing of your information with law enforcement, government
            agencies, courts, and/or other organizations on account of legal
            request such as subpoena, court order or government demand to comply
            with the law.
          </Paragraph>

          <Paragraph>
            <StrongText>Social Networks:</StrongText>
            If you interact with social media features on our Services, such as
            the Facebook Like button, or use your social media credentials to
            log-in or post content, these features may collect information about
            your use of the Services, as well as post information about your
            activities on the social media service. Your interactions with
            social media companies are governed by their privacy policies.
          </Paragraph>

          <Paragraph>
            If we believe disclosure is necessary or appropriate to protect the
            rights, property, or safety of YuCampus our customers or others.
            This includes exchanging information with other companies and
            organizations for the purposes of fraud protection and credit risk
            reduction.
          </Paragraph>

          <Paragraph>
            <StrongText>Consent:</StrongText>
            We may share your information in any other circumstances where we
            have your consent.
          </Paragraph>
        </SubSectionCard>
      </SectionCard>

      <SectionCard>
        <SubSectionTitle>
          Information Shared with Educational Institutions
        </SubSectionTitle>
        <Paragraph>
          When you enroll in courses or use educational services through our
          Services, your information is provided to us and to the educational
          institutions with whom you choose to study. In order to facilitate
          your enrollment and course participation, we provide your information
          to that institution in a similar manner as if you had enrolled
          directly with the educational institution. If you provide a mobile
          phone number, institutions or YuCampus may send you text messages
          regarding your course status or important updates. Some institutions
          also require you to provide additional information to complete your
          enrollment. When you enroll in courses through our Services and/or
          make a payment to an institution through our Services, we may also
          share with the institutions additional information, such as
          information about your learning preferences and history or information
          that we collect from third- parties.
        </Paragraph>

        <Paragraph>
          Information you choose to share with an educational institution when
          you enroll in courses and/or pay an institution through our Services
          may be used by the institution for its own purposes. We do not control
          the privacy practices of educational institutions. Please contact the
          institution directly if you want to learn about its privacy practices.
        </Paragraph>

        <SubSectionTitle>Payment Card Information</SubSectionTitle>
        <Paragraph>
          o use certain of our Services, such as to enroll in courses and to
          make payments to educational institutions, we may require credit or
          debit card account information. By submitting your credit or debit
          card account information through our Services, you expressly consent
          to the sharing of your information with educational institutions,
          third-party payment processors, and other third-party serviceproviders
          (including but not limited to vendors who provide fraud detection
          services to us and other third parties), and you further agree to the
          following terms:
        </Paragraph>

        <Paragraph>
          When you use a credit or debit card to secure enrollment through our
          Sites, we provide your credit or debit card account information
          (including card number and expiration date) to our third-party payment
          service providers and the applicable educational institution.
        </Paragraph>

        <Paragraph>
          When you initially provide your credit or debit card account
          information through our Services in order to use our payment services,
          we provide your credit or debit card account information to our third-
          party payment service providers. As explained in our Terms of Use,
          these third parties may store your credit or debit card account
          information so you can use our payment services through our Services
          in the future.
        </Paragraph>

        <Paragraph>
          For information about the security of your credit or debit card
          account information, see the "Security" section below.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>IV. Analytics and Tailored Advertising</SectionTitle>

        <Paragraph>
          To help us better understand your use of the Services, we may use
          third-party web analytics on our Services, such as Google Analytics.
          These service providers use the sort of technology described in the
          "Automatically-Collected Information" Section above. The information
          collected by this technology will be disclosed to or collected
          directly by these service providers, who use the information to
          evaluate our users' use of the Services. We also use Google Analytics
          as described in the following section. To prevent Google Analytics
          from collecting or using your information, you may install the Google
          Analytics Opt-Out Browser Add-on.
        </Paragraph>

        <SubSectionTitle>Tailored Advertising</SubSectionTitle>

        <Paragraph>
          Third parties whose products or services are accessible or advertised
          via the Services may also use cookies or similar technologies to
          collect information about your use of the Services. This is done in
          order to help them (i) inform, optimize, and serve ads based on past
          visits to our website and other sites and (ii) report how our ad
          impressions, other uses of ad services, and interactions with these ad
          impressions and ad services are related to visits to our website. We
          also allow other third parties (e.g., ad networks and ad servers such
          as Google Analytics, OpenX, Pubmatic, DoubleClick and others) to serve
          tailored ads to you on the Services, and to access their own cookies
          or similar technologies on your computer, mobile phone, or other
          device you use to access the Services. We neither have access to, nor
          does this Privacy Policy govern, the use of cookies or other tracking
          technologies that may be placed by such third parties. These parties
          may permit you to opt out of ad targeting. If you are interested in
          more information about tailored browser advertising and how you can
          generally control cookies from being put on your computer to deliver
          tailored advertising (i.e., not just for the Services), you can visit
          the Digital Advertising Alliance's Consumer Opt-Out page.
        </Paragraph>

        <Paragraph>
          To opt out of Google Analytics for Display Advertising or customize
          Google Display Network ads, you can visit the Google Ads Settings
          page. Please note that to the extent advertising technology is
          integrated into the Services, you may still receive ads even if you
          opt-out of tailored advertising. In that case, the ads will just not
          be tailored to your interests. Also, we do not control any of the
          above opt-out links and are not responsible for any choices you make
          using these mechanisms or the continued availability or accuracy of
          these mechanisms.
        </Paragraph>

        <Paragraph>
          When accessing the Services from a mobile application you may also
          receive tailored in-application advertisements. Each operating system:
          iOS, Android and Windows Phone provides its own instructions on how to
          prevent the delivery of tailored in-application advertisements. You
          may review the support materials and/or the privacy settings for the
          respective operating systems in order to opt- out of tailored
          in-application advertisements. For any other devices and/or operating
          systems, please visit the privacy settings for the applicable device
          or operating system or contact the applicable platform operator.
        </Paragraph>

        <SubSectionTitle>Do Not Track</SubSectionTitle>

        <Paragraph>
          We are committed to providing you with meaningful choices about the
          information collected on our Services for third party purposes, and
          that is why we provide the above links to opt-out mechanisms. However,
          we do not currently recognize or respond to browser-initiated Do Not
          Track signals, as the Internet industry is still working on Do Not
          Track standards, implementations and solutions.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>
          V. Choices About How We Use and Disclose Your Information
        </SectionTitle>

        <Paragraph>
          We strive to provide you with choices regarding the personal
          information you provide to us. You can set your browser or mobile
          device to refuse all or some browser cookies, or to alert you when
          cookies are being sent. To learn how you can manage your Flash cookie
          settings, visit the Flash player settings page on Adobe's website. If
          you disable or refuse cookies, please note that some parts of our
          Services may then be inaccessible or not function properly. We do not
          share your personal information with any advertising agency without
          your consent.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>VI. Communications Choices</SectionTitle>

        <Paragraph>
          When you sign up for an account, you are opting in to receive emails
          from other YuCampus users, educational institutions, and YuCampus
          itself. You can log in to manage your email preferences and you can
          follow the "unsubscribe" instructions in commercial email messages,
          but note that you cannot opt out of receiving certain administrative
          notices, service notices, or legal notices from YuCampus Technologies
          Private Limited.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>
          VII. Reviewing, Changing or Deleting Information
        </SectionTitle>

        <Paragraph>
          If you would like to review, change or delete personal information we
          have collected from you, or permanently delete your account, please
          contact the YuCampus Technologies Private Limited Privacy Officer.
        </Paragraph>

        <Paragraph>
          If you delete your User Contributions from our websites, copies of
          your User Contributions may remain viewable in cached and archived
          pages, or might have been copied or stored by other users of our
          websites. Proper access and use of information provided on our
          websites, including User Contributions, is governed by our Terms of
          Use.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>
          VIII. Accessing & Correcting Your Personal Information
        </SectionTitle>

        <Paragraph>
          We will take reasonable steps to accurately record the personal
          information that you provide to us and any subsequent updates.
        </Paragraph>
        <Paragraph>
          We encourage you to review, update, and correct the personal
          information that we maintain about you, and you may request that we
          delete personal information about you that is inaccurate, incomplete,
          or irrelevant for legitimate purposes, or are being processed in a way
          which infringes any applicable legal requirement.
        </Paragraph>
        <Paragraph>
          Your right to review, update, correct, and delete your personal
          information may be limited, subject to the law of your jurisdiction:
          (i) if your requests are abusive or unreasonably excessive, (ii) where
          the rights or safety of another person or persons would be encroached
          upon, or (iii) if the information or material you request relates to
          existing or anticipated legal proceedings between you and us, or
          providing access to you would prejudice negotiations between us or an
          investigation of possible unlawful activity. Your right to review,
          update, correct, and delete your information is subject to our records
          retention policies and applicable law, including any statutory
          retention requirements.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>
          IX. Security: How We Protect Your Information
        </SectionTitle>

        <Paragraph>
          We have implemented appropriate physical, electronic, and managerial
          procedures to safeguard and help prevent unauthorized access to your
          information and to maintain data security. These safeguards take into
          account the sensitivity of the information that we collect, process
          and store and the current state of technology. We follow generally
          accepted industry standards to protect the personal information
          submitted to us, both during transmission and once we receive it,
          including the use of vault and tokenization services from third party
          service providers. The third party service providers with respect to
          our vault and tokenization services and also our payment gateway and
          payment processing are all validated as compliant with the payment
          card industry standard (generally referred to as PCI compliant service
          providers). However, no method of transmission over the Internet or
          via mobile device, or method of electronic storage, is 100% secure.
          Therefore, while we strive to use commercially acceptable means to
          protect your personal information, we cannot guarantee its absolute
          security and thereby usage in a manner that is inconsistent with this
          Privacy Policy.
        </Paragraph>
        <Paragraph>
          We assume no liability or responsibility for disclosure of your
          information due to errors in transmission, unauthorized third-party
          access, or other causes beyond our control. You play an important role
          in keeping your personal information secure. You should not share your
          user name, password, or other security information for your YuCampus
          account with anyone. If we receive instructions using your user name
          and password, we will consider that you have authorized the
          instructions.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>X. Third Party Links and Services</SectionTitle>
        <Paragraph>
          The Services may contain links to third-party websites. Your use of
          these features may result in the collection, processing or sharing of
          information about you, depending on the feature. Please be aware that
          we are not responsible for the content or privacy practices of other
          websites or services which may be linked on our services. We do not
          endorse or make any representations about third-party websites or
          services. Our Privacy Policy does not cover the information you choose
          to provide to or that is collected by these third parties. We strongly
          encourage you to read such third parties' privacy policies.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>
          XI. Compliance with Data Protection Regulations
        </SectionTitle>
        <Paragraph>
          The information we obtain from or about you may be processed and
          stored in India and our other various servers located across the
          globe, which may provide for different data protection rules than the
          country in which you reside. We comply with generally accepted
          industry standard regulations regarding the collection, use, and
          retention of data. Each location may provide for different data
          protection rules than the country in which you reside. By using the
          Services, you consent to the collection, transfer, use, storage and
          disclosure of your information as described in this Privacy Policy,
          including to the transfer of your information outside of your country
          of residence. If you have any questions relating to your personal
          data, please write to us.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>XII. Data Retention and Account Termination</SectionTitle>
        <Paragraph>
          You can close your account by visiting your profile settings page on
          our website. We will remove your public posts from view and/or
          dissociate them from your account profile, but we may retain
          information about you for the purposes authorized under this Privacy
          Policy unless prohibited by law. Thereafter, we will either delete
          your personal information or de-identify it so that it is anonymous
          and not attributed to your identity. For example, we may retain
          information to prevent, investigate, or identify possible wrongdoing
          in connection with the Service or to comply with legal obligations.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>XIII. Job Applicants</SectionTitle>
        <Paragraph>
          If your information is submitted to us through our Service when
          applying for a position with our company, the information will be used
          to consider your application. We may retain your information forany
          period of time. This information may be shared with other companies
          for the purpose of evaluating your qualifications for the particular
          position or other available positions, as well as with third-party
          service providers retained by us to collect, maintain and analyze
          candidate submissions for job postings.
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>XIV. Changes to This Privacy Policy</SectionTitle>
        <Paragraph>
          We reserve the right to amend this Privacy Policy from time to time to
          reflect changes in the law, our data collection and use practices, the
          features of our services, or advances in technology. Please check this
          page periodically for changes. Use of information we collect is
          subject to the Privacy Policy in effect at the time such information
          is used. If we make any material changes to this Privacy Policy, we
          will post the changes here. Please review the changes carefully. Your
          continued use of the Services following the posting of changes to this
          Privacy Policy will constitute your consent and acceptance of those
          changes.{" "}
        </Paragraph>
      </SectionCard>

      <SectionCard>
        <SectionTitle>XV. Contact Us</SectionTitle>
        <Paragraph>
          If you have any queries relating to the processing/usage of
          information provided by you or YuCampus Technologies Private Limited
          Privacy Policy, you may email us.
        </Paragraph>

        <StrongText>For Users:</StrongText>
        <br/>
        <div>
          <ContactName>Prashant Gupta</ContactName>
          <ContactTitle>Privacy Officer</ContactTitle>
          <CompanyName>YuCampus Technologies Private Limited</CompanyName>
          <OfficeAddress>Office: M-11, south extension part-2</OfficeAddress>
        </div>

        <Note>
          Yucampus operates the website
          <Link
            href="https://www.yucampus.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            yucampus.com
          </Link>
          and the corresponding mobile application on Android & iOS platforms.
        </Note>
      </SectionCard>
    </Container>
  );
};



export default PrivacyContent;
